import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItemText } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';
import { infos } from '../../../../model/infos';
import SaveButton from '../../../../ui-components/Button/SaveButton';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import NewItemIconButton from '../../../../ui-components/Button/NewItemIconButton';
import TextField from '../../../../ui-components/TextField/TextField';
import { contact } from '../../../../model/contact';
import DeleteIconButton from '../../../../ui-components/Button/DeleteIconButton';

// interface IProps extends IMediaQueryProps, IInfosActions, IInfosState, IIProps {
// }

interface IIProps extends StyledComponentProps {
    // IContactActions,
    onCancel: () => any;
    onDelete: (id: string) => any;
    onSave: (info: infos) => any;
    open: boolean;
    isLoadingInfos: boolean;
    informations: infos[];
    contact: contact;
    // canChangeContact?: boolean;
}

// interface IState {
//     informations: infos[];
//     contact: contact;
//     edit: boolean;
// }

export const InformationDialog = (props: IIProps) => {

    const [edit, setEdit] = React.useState<boolean>(false);
    const [id, setId] = React.useState<string>();
    const [typof, setTypof] = React.useState<string>();
    const [info, setInfo] = React.useState<string>();

    // constructor(p, c) {
    //     super(p, c);
    //     this.state = {
    //         informations: this.props.informations,
    //         // contact: emptyContact(),
    //         // reservationList: NormalizedObjectsFactory()
    //     }
    // }

    const update = async (info: infos) => {
        console.log("update info:", info);
        // info: {_id: '5f17754ff5ba415b7fd8049f', sub: null, cardNumber: '17069', info: 'Visita medica del 25/10/2017 scade il 10/06/2020', typof: null}
        setId(info._id);
        setTypof(info.typof === null ? "" : info.typof);
        setInfo(info.info);
        setEdit(true);
    }
    const newinfo = async () => {
        // console.log("update info:", info);
        // info: {_id: '5f17754ff5ba415b7fd8049f', sub: null, cardNumber: '17069', info: 'Visita medica del 25/10/2017 scade il 10/06/2020', typof: null}
        setEdit(true);
    }
    const deleteinfo = async () => {
        // console.log("update info:", info);
        // info: {_id: '5f17754ff5ba415b7fd8049f', sub: null, cardNumber: '17069', info: 'Visita medica del 25/10/2017 scade il 10/06/2020', typof: null}
        // setEdit(true);
        props.onDelete(id);
        setEdit(false);
    }
    const saveinfo = async () => {
        // console.log("update info:", info);
        // info: {_id: '5f17754ff5ba415b7fd8049f', sub: null, cardNumber: '17069', info: 'Visita medica del 25/10/2017 scade il 10/06/2020', typof: null}
        // 
        var i: infos = {
            _id: id,
            typof: typof,
            info: info,
            sub: props.contact.sub,
            cardNumber: props.contact.cardNumber,
        };
        props.onSave(i);
        setEdit(false);
    }
    // componentDidMount() {
    // }
    // componentDidUpdate(prevProps: IProps) {
    //     // if (this.props.reminder !== undefined && prevProps.reminder !== undefined ) {
    //     // if (this.props.reminder._id !== prevProps.reminder._id) {
    //     //     this.setState({ reminder: this.props.reminder });
    //     // }
    // }
    React.useEffect(() => {
    }, []);

    React.useEffect(() => {
        console.log("use effect edit:", edit)
        if (edit === false) {
            setId("");
            setTypof("");
            setInfo("");
        }
    }, [edit]);

    //render() {
    // const { classes } = props;
    var title = "Informazioni anagrafiche utente";
    return (
        <Dialog
            open={props.open}
            onClose={(e) => props.onCancel()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
            <DialogContent>
                <Grid container>
                    <List className={props.classes.root}>
                        {props.informations && props.informations.map((c, index) =>
                            <span key={index}>
                                <ListItemText onDoubleClick={() => update(c)} primary={c.typof} secondary={c.info} primaryTypographyProps={{ noWrap: false, variant: 'body1', style: { display: 'block' } }} />
                            </span>
                        )}
                    </List>
                </Grid>
            </DialogContent >
            <DialogActions>
                {edit ?
                    <Grid container spacing={1} style={{ display: 'grid', padding: '10px', width: '330px' }}>
                        <TextField value={typof} onChange={val => setTypof(val)} label='Tipo informazione' />
                        <TextField value={info} onChange={setInfo} label='' />
                    </Grid>
                    : <></>}
                {edit ?
                    <>
                        <DeleteIconButton onClick={deleteinfo} />
                        <SaveButton onClick={saveinfo} />
                    </>
                    :
                    <NewItemIconButton onClick={newinfo} />
                }
                <CancelButton onClick={props.onCancel} />
            </DialogActions>
        </Dialog >
    );
}